export default __webpack_public_path__ + "static/media/fanzone-club-cards.6f36d457.png";